import { GlobalAppState } from '@model/state';

export const getTourSummary = (state: GlobalAppState) => state.tours.tourSummary;
